import React from 'react';
import './Menu.css';

export default function Menu() {
  return (
    <div className="page menu-page" dir="rtl">
      {/* <h2 className="menu-title">התפריט שלנו</h2> */}
      <div className="menu-grid">

        <div className="menu-item">
          <img src="/images/sandwich.png" alt="כריך" />
          <h3>🥪 כריכים</h3>
          <p>מבחר כריכים טריים ולחמים מיוחדים</p>
        </div>

        <div className="menu-item">
          <img src="/images/pretzel.jpg" alt="בייגלה" />
          <h3>🥨 בייגלה</h3>
          <p>חם, טרי, ורך מבפנים</p>
        </div>

        <div className="menu-item">
          <img src="/images/coffee_and_croissoant.png" alt="קפה ומאפה" />
          <h3>☕ קפה ומאפה</h3>
          <p>קפה משובח לצד קרואסון</p>
        </div>

        <div className="menu-item">
          <img src="/images/juices.jpg" alt="מיץ טבעי" />
          <h3>🍊 מיץ טבעי</h3>
          <p>נסחט יום-יום באהבה</p>
        </div>

        <div className="menu-item">
          <img src="/images/ices.png" alt="פינוקי קרח" />
          <h3>🧊 פינוקי קרח </h3>
          <p>אייס קפה / אייס וניל - קפוא ומרענן!</p>
        </div>

      </div>
    </div>
  );
}
